import { render, staticRenderFns } from "./qianBottomNav.vue?vue&type=template&id=9b26e4a8&scoped=true&"
import script from "./qianBottomNav.vue?vue&type=script&lang=js&"
export * from "./qianBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./qianBottomNav.vue?vue&type=style&index=0&id=9b26e4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26e4a8",
  null
  
)

export default component.exports